import BaseController from "confinus_ui/base_controller";

// Controller for the admin-warning banner shown on every storefront page when
// an admin is signed in. The banner contains a <select> that switches the
// catalog being previewed by writing/replacing `?_c=<encoded_id>` on the
// current URL and reloading.
//
// Wired to `change` on the root via the component's `stimulus do; actions
// [:change, :switch_catalog]; end` block. The native <select>'s change event
// bubbles up to the root element and triggers `switchCatalog`. No other
// element in the subtree emits `change`, so a single root-level binding is
// safe (cf. the root-action pitfall for click).
export default class AdminWarningController extends BaseController {
  public switchCatalog(event: Event): void {
    const target = event.target as HTMLSelectElement | null;
    if (!target) return;
    const url = window.location.href;
    const noC = url.match(/_c=/) == null;
    const q = "_c=" + target.value;
    window.location.href = noC
      ? `${url}?${q}`
      : url.replace(/_c=[a-z\-0-9]+/, q);
  }
}
